import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment'; 
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpiringContractsService {
  constructor(private http: HttpClient) {}
  getVendorExpiringMSA(): Observable<any> {
    const apiUrl = `${environment.apiUrl}/ops/vendor-expiring-msa`;
    return this.http.get<any>(apiUrl);
  }
}